// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  FormLabelInput,
  TitleInputContainer,
  TitleDescription,
  MessageInputContainer,
  FormLabel,
  InputContainer,
  FormInput,
  FormNote,
} from "@/components/ui/form-elements";
import { Checkbox } from "@/components/ui/checkbox";
import EdsSearchableSelect from "../EdsSearchableSelect";
import NodeContext from "../../context/NodeContext";
import { useContext } from "react";
import { ALLOWED_FILE_TYPES, toolbar } from "../../utils/constants";
import { Editor } from "react-draft-wysiwyg";
import { getHTMLToDraft } from "../../utils/helper";
import ResponseVariable from "../ResponseVariable/index";
import { LABELS } from "../../utils/labels";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { VAR_DEFAULT_FASTTRACK_ADD_DOCUMENT_TO, VAR_DEFAULT_RDB_ADD_DOCUMENT_TO, VAR_DEFAULT_SALESFORCE_ADD_DOCUMENT_TO } from '../../utils/constants'
import { Switch } from "@/components/ui/switch";
import { FLOW_TYPE_SCREENING, FLOW_TYPE_RECONNECT, FLOW_TYPE_FAQ } from "../../constants";

function FileUploadNodeEditor() {
  const {
    selectedNodeInfo,
    updateNode,
    variableList,
    atsData,
    isEditable,
    setNewAddedNode,
    saveData,
    atsPlatform,
    profileType,
    documentType
  } = useContext(NodeContext);
  const [displayError, setDisplayError] = useState(
    selectedNodeInfo.data.isVariableNameAlreadyUsed ?? false
  );

  if (!selectedNodeInfo) {
    return null;
  }
  return (
    <>
      <TitleInputContainer>
        <FormLabelInput
          placeholder="Label"
          value={selectedNodeInfo?.data?.titleText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              titleText: e.target.value,
            });
          }}
          readOnly={!isEditable}
        />
        <TitleDescription>Allows the user to upload files in the defined format as below</TitleDescription>
      </TitleInputContainer>
      <MessageInputContainer>
        <div className="flex w-full items-center justify-between">
          <FormLabel className="mb-0">{LABELS.SHOW_MESSAGE}</FormLabel>
          {[FLOW_TYPE_SCREENING, FLOW_TYPE_RECONNECT, FLOW_TYPE_FAQ].includes(profileType) && (
            <Tooltip title="When enabled, the candidate can skip this question without providing an answer">
              <div className="flex items-center gap-2">
                <FormLabel className="mb-0 font-12px">{LABELS.SKIPPABLE}</FormLabel>
                <Switch
                  checked={selectedNodeInfo?.data?.isSkippable ?? false}
                  onCheckedChange={(checked) => {
                    updateNode(selectedNodeInfo.id, {
                      ...selectedNodeInfo?.data,
                      isSkippable: checked,
                      ...(!checked && { skipToNodeId: "" }),
                    });
                  }}
                  disabled={!isEditable}
                />
              </div>
            </Tooltip>
          )}
        </div>
        {/* <CKEditor
                    editor={ClassicEditor}
                    config={{
                        toolbar: [
                            "bold",
                            "italic",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "blockQuote",
                        ],
                        placeholder: "What is your...",
                    }}
                    onChange={(_, editor) => {
                        const data = editor.getData();
                        updateNode(selectedNodeInfo.id, {
                            ...selectedNodeInfo?.data,
                            message: data,
                        });
                    }}
                    data={selectedNodeInfo?.data?.message}
                /> */}
        <Editor
          editorState={getHTMLToDraft(selectedNodeInfo?.data?.message)}
          onEditorStateChange={(data) => {
            const isMessageEmpty = data.getCurrentContent().hasText();
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              message: data,
              isMessageEmpty: !isMessageEmpty,
            });
          }}
          onBlur={() => {
            setNewAddedNode(true);
          }}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          toolbar={toolbar}
          mention={{
            separator: " ",
            trigger: "{",
            suggestions: variableList,
          }}
          placeholder="What is your..."
          readOnly={!isEditable}
          stripPastedStyles={true}
        />
      </MessageInputContainer>

      <MessageInputContainer key={selectedNodeInfo?.id}>
        <FormLabel>{LABELS.FILE_TYPE}</FormLabel>
        <div className="grid grid-cols-3 gap-3">
          {ALLOWED_FILE_TYPES.map((type) => (
            <div className="flex items-center space-x-2  [&:not(:nth-child(3n+1))]:ml-5" key={type}>
            <Checkbox
              className="mb-2"
                id={type}
                checked={selectedNodeInfo?.data?.allowedFileTypes?.includes(
                  type
                )}
                onCheckedChange={(checked) => {
                  const allowedFileTypes =
                    selectedNodeInfo?.data?.allowedFileTypes || [];
                  if (!checked) {
                    updateNode(selectedNodeInfo.id, {
                      ...selectedNodeInfo?.data,
                      allowedFileTypes: allowedFileTypes.filter(
                        (t) => t !== type
                      ),
                    });
                  } else {
                    updateNode(selectedNodeInfo.id, {
                      ...selectedNodeInfo?.data,
                      allowedFileTypes: [...allowedFileTypes, type],
                    });
                  }
                }}
                disabled={!isEditable}
              />
              <label
                htmlFor={type}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 CheckLable"
              >
                {type}
              </label>
            </div>
          ))}
        </div>
      </MessageInputContainer>

      <InputContainer>
        <FormLabel>{LABELS.INPUT_SUGGESTION}</FormLabel>
        <FormInput
          placeholder="Enter Suggestion"
          value={selectedNodeInfo?.data?.suggestionText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              suggestionText: e.target.value,
            });
          }}
          readOnly={!isEditable}
        />
      </InputContainer>
      <InputContainer>
        <FormLabel>{LABELS.INPUT_VALIDATION}</FormLabel>
        <FormInput
          placeholder="Enter Validation Message"
          value={selectedNodeInfo?.data?.validationText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              validationText: e.target.value,
            });
          }}
          readOnly={!isEditable}
        />
      </InputContainer>
      <InputContainer>
        {atsPlatform === "FASTTRACK" && [36, 37].includes(profileType) && (
          <>
            <FormLabel>{LABELS.ATS_ADD_DOCUMENT}</FormLabel>
            <EdsSearchableSelect
              options={VAR_DEFAULT_FASTTRACK_ADD_DOCUMENT_TO}
              value={selectedNodeInfo?.data?.atsDocumentType || ""}
              onChange={(value) => {
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  atsDocumentType: value || null,
                });
              }}
              placeholder="Select document type"
              isDisabled={!isEditable}
              isClearable={true}
            />
          </>
        )}
        {atsPlatform === "RDB" && [36, 37].includes(profileType) && (
          <>
            <FormLabel>{LABELS.ATS_ADD_DOCUMENT}</FormLabel>
            <EdsSearchableSelect
                options={documentType}
                value={selectedNodeInfo?.data?.atsDocumentType || ""}
                onChange={(value) => {
                    updateNode(selectedNodeInfo.id, {
                        ...selectedNodeInfo?.data,
                        atsDocumentType: value || null,
                    });
                }}
                placeholder="Select document type"
                isDisabled={!isEditable}
                isClearable={true}
            />
          </>
        )}
        {documentType && atsPlatform === "ARCRM" && [36, 37, 89].includes(profileType) && (
          <>
            <FormLabel>{LABELS.ATS_ADD_DOCUMENT}</FormLabel>
            <EdsSearchableSelect
              options={[
                {
                  label: 'Candidate CV',
                  options: documentType.filter((item) => item.value === '-1'),
                },
                {
                  label: 'Stored Document',
                  options: documentType.filter((item) => item.value !== '-1'),
                },
              ]}
              value={selectedNodeInfo?.data?.atsDocumentType || ""}
              onChange={(value) => {
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  atsDocumentType: value || null,
                });
              }}
              placeholder="Select document type"
              isDisabled={!isEditable}
              isClearable={true}
            />
          </>
        )}
        {atsPlatform === "SALESFORCE"&& [36, 37].includes(profileType) && (
          <>
            <FormLabel>{LABELS.ATS_ADD_DOCUMENT}</FormLabel>
            <EdsSearchableSelect
              options={VAR_DEFAULT_SALESFORCE_ADD_DOCUMENT_TO}
              value={selectedNodeInfo?.data?.atsDocumentType || ""}
              onChange={(value) => {
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  atsDocumentType: value || null,
                });
              }}
              placeholder="Select document type"
              isDisabled={!isEditable}
              isClearable={true}
            />
          </>
        )}
        {atsPlatform !== "ARCRM" && documentType && [36, 37].includes(profileType) && (
          <>
            <FormLabel>{LABELS.ATS_ADD_DOCUMENT}</FormLabel>
            <EdsSearchableSelect
              options={documentType}
              value={selectedNodeInfo?.data?.atsDocumentType || ""}
              onChange={(value) => {
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  atsDocumentType: value || null,
                });
              }}
              placeholder="Select document type"
              isDisabled={!isEditable}
              isClearable={true}
            />
          </>
        )}
        <ResponseVariable
          updateNodeFun={updateNode}
          selectedNodeInfo={selectedNodeInfo}
          iseditable={isEditable ? "true" : undefined}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "2px",
            width: "100%",
          }}
        >
          <FormInput
            placeholder="Enter Variable Name"
            value={selectedNodeInfo?.data?.variableName}
            onBlur={(e) => {
              setNewAddedNode(true);
            }}
            onChange={(e) => {
              if (e.target.value.length > 60) {
                return;
              }
              const isVariableNameAlreadyUsed = variableList.find(
                (item) => item.value === `{${e.target.value.trim()}}}`
              );
              if (isVariableNameAlreadyUsed) {
                setDisplayError(true);
              } else {
                setDisplayError(false);
              }

              updateNode(selectedNodeInfo.id, {
                ...selectedNodeInfo?.data,
                variableName: e.target.value,
                isVariableNameAlreadyUsed: isVariableNameAlreadyUsed
                  ? true
                  : false,
              });
            }}
            readOnly={!isEditable}
          />
          {displayError && (
            <Tooltip title="This variable has already been used.">
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                style={{
                  color: "#ffcc00",
                  fontSize: "18px",
                  display: "",
                  position: "absolute",
                  right: "40px",
                }}
              />
            </Tooltip>
          )}
        </div>
        <FormNote>
          You can add a variable that can be referenced later in the
          conversation.
        </FormNote>
      </InputContainer>
    </>
  );
}

export default FileUploadNodeEditor;
